<template>
     <div class="article-right">
       <div class="videoList-header">
            <Search class="searchWidth" @inputKey="inputKey"></Search>
            <div class="classification" v-show="type == 2">
                <el-dropdown>
                    <span class="el-dropdown-link" >
                        <span  v-show="dropdownTitle == ''">分类</span>
                        <span  v-show="dropdownTitle != ''">{{ dropdownTitle }}</span>
                        
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" >
                        <el-dropdown-item @command="handleAll()">
                            <span @click="handleAll()">
                                全部
                           </span>
                        </el-dropdown-item>
                        <el-dropdown-item v-for="item,index in maintypeData" :key="item.cate_id" :index="index+2" @command="handleListarticle(item)">
                           <span @click="handleListarticle(item)">
                            {{ item.cate_name }}
                           </span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
       </div>
        <div class="videoListBox">
            <div v-for="item in videoList" :key="item.id"  v-show="activeIndex == 1">
                <div class="videoContent-div" >
                    <div style="height: 150px;">
                            <videoPlayer :mp4Url="item.file_url" :mp4Pic="item.firstFile.FileUrl"></videoPlayer>
                    </div>
                    <div @click="getVideoInfo(item)">
                        <p class="videoTitle">{{ item.name }}</p>
                        
                        <p class="cate-context">
                            {{ item.cate_name }}
                            <span>|</span>
                            观看次数{{ item.click_amount }}
                        </p>
                        <p class="cate-context" style="margin-top: 0;">发布者：<span>{{ item.author }}</span></p>
                    </div>
                    
                </div>
            </div>

            <div v-for="item in coursewareList" :key="item.id" v-show="activeIndex == 3" @click="getCoursewareInfo(item)">
                <div class="videoContent-div">
                    <div :style="'background-image:url('+item.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;'"></div>
                    <p class="videoTitle">{{ item.name }}</p>
                </div>

            </div>
            <div v-for="item in listliveList" :key="item.id" v-show="activeIndex == 2"  @click="getListLiveInfo(item)">
                <div class="videoContent-div">
                    <div :style="'width: 280px; height: 200px;background-image:url('+item.firstFile.FileUrl+');background-size: cover;background-repeat: no-repeat;background-position: center;'"></div>
                    <p class="videoTitle">{{ item.name }}</p>
                </div>

            </div>
        </div>
        <div class="pagination">
            <el-pagination
                :hide-on-single-page="hideOnSinglePage"
                :page-size="9"
                :pager-count="widthNew?11:5"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </div>

        
        
    </div>
</template>
<script>
import Search from '../search/index.vue'
// 引入MP4组件
import videoPlayer from './videoPlayer.vue'

export default {
    props: ['videoData','type','activeIndex'],
    data(){
        return{
            parent_cate_value: ['maintype'],
            maintypeData:[],
            cate: '',
            keywords: '',
            videoList: [],
            coursewareList:[],
            total: 0,
            hideOnSinglePage: true,
            dropdownTitle: '',
            listliveList: [],
            widthNew: false

        }
    },
    watch: {
        videoData(newVal,oldVal){
            console.log("新传的newVal");
            console.log(newVal);
            console.log(oldVal);
            this.getVideoList(newVal)
        },
        activeIndex(newVal,oldVal){
            console.log(oldVal);
            let data = {
                    pageNum: 1,
                    pageSize: 20,
                    cate: this.cate,
                    keywords: this.keywords
                }
            if(newVal == 3){ //课件
                
                this.handleCourseware(data)
            }else if(newVal == 2){ // 直播
                this.handlListlive(data)
            }
        }
    },
    components:{
        Search,
        videoPlayer
    },
    methods:{
         //   获取菜单
         getMenuList(){
            const data = {
                pageNum: 1,
                pageSize: 999999,
                cate_values: 'maintype'
            }
            this.$store.dispatch('menu/menuList', data)
                .then((res) => {
                    console.log(res);
                    this.maintypeData = []
                    if(res.ok){
                        const list = res.data.items
                        list.forEach(item => {
                            if(item.p_cate_value == 'maintype'){
                                this.maintypeData.push(item)
                            }
                        });
                    }
                
                })
                .catch((err) => {
                    
                    console.log(err);
                }) 
        },
        getVideoList(data){
            this.$store.dispatch('video/listvideo',data)
                .then(res => {
                    console.log(res);
                    if(res.ok){
                        // res.data.items.forEach(item => {
                        //     item.file_url = item.file_url.replace('http:', 'https:')
                        // })
                        this.videoList = res.data.items
                        this.total = res.data.total
                        if(this.total <= 9){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                })
        },
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            // this.currentChange = val
            // console.log(value);
            let data = {
                pageNum: val,
                pageSize: 9,
                cate: this.cate,
                keywords: this.keywords,
            }
            this.getVideoList(data)
        },
        getVideoInfo(item){
            console.log("aidfjdfldjf-----");
            console.log(item);

            
            const { href } = this.$router.resolve({
                path: "/videoDetail",
                query: {
                    key: item.id,
                    currentName: '视频详情'
                }
            });
            window.open(href, '_blank');
        },
        getCoursewareInfo(item){
            
            const { href } = this.$router.resolve({
                path: "/courseware",
                query: {
                    key: item.id,
                }
            });
            window.open(href, '_blank');
        },
        getListLiveInfo(item){
            const { href } = this.$router.resolve({
                path: "/listlive",
                query: {
                    key: item.id,
                }
            });
            window.open(href, '_blank');
        },
        inputKey(val){
            this.keywords = val
            this.$emit('keywordsInput',val)
            let data = {
                pageNum: 1,
                pageSize: 9,
                cate: this.cate,
                keywords: val,
            }
            if(this.activeIndex == 1){
                
                this.getVideoList(data)
            }else if(this.activeIndex == 2){
                this.handlListlive(data)
            }else if(this.activeIndex == 3){
                this.handleCourseware(data)
            }
        },
        handleListarticle(value){
            console.log("777777777");
            this.cate = value.cate_id
            console.log(value);
            this.dropdownTitle = value.cate_name
            let data = {
                pageNum: 1,
                pageSize: 9,
                cate: value.cate_id,
                keywords: this.keywords,
            }
            if(this.activeIndex == 1){
                this.getVideoList(data)
            }else if(this.activeIndex == 3){ 
                this.handleCourseware(data)
            }else if(this.activeIndex == 2){
                this.handlListlive(data)
            }
           
        },
        handleAll(){
            this.dropdownTitle = '全部'
            this.cate = ''
            let data = {
                pageNum: 1,
                pageSize: 9,
                cate: this.cate,
                keywords: this.keywords,
            }
            if(this.activeIndex == 1){
                this.getVideoList(data)
            }else if(this.activeIndex == 3){
                this.handleCourseware(data)
            }else if(this.activeIndex == 2){
                this.handlListlive(data)
            }
        },
        // 课件
        handleCourseware(data){
            this.$store.dispatch('video/listcourse', data)
                .then((res) => {
                    if(res.ok){
                        this.coursewareList = res.data.items
                        this.total = res.data.total

                        if(this.total <= 9){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                
                }).catch((err) => {
                    
                    console.log(err);
                }) 
        },
        // 直播
        handlListlive(data){
            this.$store.dispatch('video/listlive', data)
                .then((res) => {
                    if(res.ok){
                        this.listliveList = res.data.items
                        this.total = res.data.total

                        if(this.total <= 9){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                
                }).catch((err) => {
                    
                    console.log(err);
                }) 
        },
    },
    
    mounted(){
        // this.$refs.videoPlayer.play();
        console.log("9090909090000000000000");
        console.log(this.type);
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        let data = {
            pageNum: 1,
            pageSize: 9,
            cate: '',
            keywords: '',
        }
        this.getVideoList(data)
        // this.getMenuList()
    }

}
</script>

<style scoped>
.searchWidth{
    margin-bottom: 40px;
    width: 600px;
}
.videoContent-div{
    width: 300px;height: 300px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    cursor: pointer;
} 
.videoContent-div div{
    width: 280px; height: 200px;
}

.videoListBox{
    width: 945px;
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
}
.videoListBox div{
    width: 292px;height: 280px;
    margin: 0px 20px 20px 0;
}
.videoTitle{
    font-size: 18px;
    height: 50px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    padding: 5px 10px 5px 10px;
}
.cate-context{
    font-size: 13px;
    margin-top: 10px;
    color: #999999;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.pagination{
    width: 100%;
    margin-top: 40px;
    text-align: right;
}
.videoList-header{
    display: flex;
    justify-content: space-between;
}
.classification{
    width: 200px;
    text-align: right;
    color: #00a8a8;
}
.el-dropdown-link:hover{
    font-weight: bold;
}
.el-dropdown-link {
    cursor: pointer;
    font-size: 18px;
    color: #00a8a8;
}
.el-icon-arrow-down {
    font-size: 18px;
}
@media screen and (min-width: 541px) {
    .article-right{
        width: 920px;
        /* margin-left: 10px; */
        background: #fff;
        padding: 15px 15px;
    
    }
}
@media screen and (max-width: 540px) {
    .article-right{
        width: 95%;
        margin: 10px auto;
        padding: 15px 8px;
        background: #fff;
    }
    .searchWidth{
        padding-left: 8px;
        margin-bottom: 40px;
        width: 60%
    }
    .videoListBox{
        width: 100%;
    }
    
    .videoListBox div{
        width: 320px;height: 290px;
        margin: 0px 20px 30px 0;
    }
    .videoContent-div{
        padding: 8px 8px;
        width: 600px;height: 300px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        cursor: pointer;
    } 
    .videoContent-div div{
        width: 320px; height: 220px;
    }

    .videoTitle{
        font-size: 16px;
    }
  }

</style>
<style>


.el-dropdown-menu .el-dropdown-menu__item:hover { 
    color: #00a8a8 !important;
    background-color: rgb(0, 168, 168, 0.1);

}

  </style>